import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { BalloonPopupService } from './balloon-popup.service';

@Directive({ selector: '[balloon-origin]' })
export class BalloonPopupOriginDirective implements AfterViewInit, OnDestroy {

  constructor(
    private readonly elRef: ElementRef,
    private readonly balloonPopupService: BalloonPopupService
  ) {}

  ngAfterViewInit() {
    this.balloonPopupService.setAttachedElement(this.elRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.balloonPopupService.removeAttachedElement();
  }
}


// WEBPACK FOOTER //
// ./ts/app/shared/balloon-popup/balloon-popup-origin.directive.ts